// extracted by mini-css-extract-plugin
export default {"container":"HeaderBurguer_container__eppla","containerBlack":"HeaderBurguer_containerBlack__2QpVA","logo":"HeaderBurguer_logo__T2c91"};